export default __webpack_public_path__ + "static/clean-ingredients_experts_Robert-Jackler-db708401168450e2f1ce1c584fa6cba5.png";